export default __webpack_public_path__ + "static/media/cross.b290548a.png";